import { Editor } from '@tiptap/core'

export function getWordcountWithoutTitle(editor: Editor | null) {
  if (editor === null) return 0

  const text = editor.getText()
  const [title] = text.split('\n')
  const titleWordCount = title.split(' ').length

  return editor.storage.characterCount.words() - titleWordCount
}
